export class ManageRoles {
    public productId: number;
    public authorizationType: string;
    public authRole: string;
    public authCode: string;
    public rolesDescription: string;
    public updatedBy: string
}


// WEBPACK FOOTER //
// ./src/app/models/manageroles.ts